import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    fetchAuthTokens,
    fetchAuthTokensWaf,
    fetchWafCaptchaActive,
} from '@perpay-web/fintech/actions/authentication';
import LoginForm from '@perpay-web/fintech/components/composite/LoginForm/LoginForm';
import {
    getLoginLoading,
    getErrors,
    getIsExistingUser,
    getIsWafCaptchaActive,
    getShowWafCaptcha,
    getMFA,
} from '@perpay-web/fintech/selectors/authentication';

const LoginFormContainer = () => {
    const dispatch = useDispatch();
    const errors = useSelector(getErrors);
    const loginLoading = useSelector(getLoginLoading);
    const wafCaptchaActive = useSelector(getIsWafCaptchaActive);
    const showWafCaptcha = useSelector(getShowWafCaptcha);
    const mfa = useSelector(getMFA);
    const isExistingUser = useSelector(getIsExistingUser);

    const onSubmit = useCallback(
        (credentials) =>
            dispatch(
                wafCaptchaActive
                    ? fetchAuthTokensWaf(credentials)
                    : fetchAuthTokens(credentials),
            ),
        [dispatch, wafCaptchaActive],
    );

    const onMount = useCallback(() => {
        dispatch(fetchWafCaptchaActive());
    }, [dispatch]);

    return (
        <LoginForm
            onMount={onMount}
            onSubmit={onSubmit}
            isLoading={loginLoading}
            errors={errors}
            wafCaptchaActive={wafCaptchaActive}
            showWafCaptcha={showWafCaptcha}
            mfa={mfa}
            isExistingUser={isExistingUser}
        />
    );
};

export default LoginFormContainer;
